import DOMPurify from 'dompurify';

import { P1 } from '@zooplus/ui-components';

type HTMLParserProps = {
  content?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tagName?: any;
  customStyle?: string;
};

export const HTMLParser = ({ content, tagName, customStyle, ...rest }: HTMLParserProps) => {
  const Tag = tagName || P1;
  const sanitizedContent = content
    ? DOMPurify.sanitize(content, { ADD_ATTR: ['target', 'rel'] })
    : '';

  return (
    <Tag dangerouslySetInnerHTML={{ __html: sanitizedContent }} className={customStyle} {...rest} />
  );
};
